const chatbot = {
  CHATBOT_MESSAGE_WELCOME:
    '¡Bienvenido al chat de Plika 👋 \n Soy un asistente virtual, puedo compartirte información sobre la plataforma.',
  CHATBOT_MESSAGE_HELP: '¿En qué te puedo ayudar?',
}

export default chatbot
